module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/068-djibouti-42b59d641a65af59d7958b6f077010df.svg";